import { Table } from "reactstrap";
import { Tooltip } from "@mui/material";
import "./CHMTableComponents.css";

export interface Column<T = any> {
  header: string;
  accessor?: keyof T | string;
  sticky?: "left" | "right";
  width?: number | string;
  className?: string;

  /** Custom cell renderer */
  cell?: (row: T, rowIndex: number) => React.ReactNode;

  /** Tooltip support */
  tooltip?: (row: T) => React.ReactNode;
}

interface ReusableTableProps<T> {
  columns: Column<T>[];
  data: T[];
  rowKey?: (row: T, index: number) => string;
  onRowClick?: (row: T) => void;
}

const ReusableTable = <T,>({
  columns,
  data,
  rowKey,
  onRowClick,
}: ReusableTableProps<T>) => {
  return (
    <div className="table-scroll-container">
      <Table striped hover bordered responsive>
        <thead>
          <tr className="aligne-center">
            {columns.map((col, index) => (
              <th
                key={index}
                className={col.sticky ? `sticky-${col.sticky}` : ""}
                style={
                  col.sticky === "left"
                    ? { position: "sticky", left: 0, zIndex: 2 }
                    : undefined
                }
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data?.map((row, rowIndex) => (
            <tr
              key={rowKey ? rowKey(row, rowIndex) : rowIndex}
              // className={`aligne-center cursor-pointer  ${rowIndex === 0 ? "highlight-row" : ""}`}
              className={`aligne-center cursor-pointer`}
            >
              {columns.map((col, colIndex) => {
                const value =
                  col.accessor && typeof col.accessor === "string"
                    ? (row as any)[col.accessor]
                    : "--";

                const cellContent = col.cell
                  ? col.cell(row, rowIndex)
                  : (value ?? "--");

                return (
                  <td
                    key={colIndex}
                    className={col.className}
                    style={
                      col.sticky === "left"
                        ? { position: "sticky", left: 0, background: "#fff" }
                        : undefined
                    }
                    onClick={() => onRowClick?.(row)}
                  >
                    {col.tooltip ? (
                      <Tooltip
                        title={col.tooltip(row)}
                        placement="bottom"
                        componentsProps={{
                          tooltip: { sx: { backgroundColor: "black" } },
                        }}
                      >
                        <span className="ellipsis-cell">{cellContent}</span>
                      </Tooltip>
                    ) : (
                      <span
                        className={`ellipsis-cell ${col.header === "Status" && col.className} `}
                      >
                        {cellContent}
                      </span>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ReusableTable;
